'use client'
import Link from 'next/link'
import React from 'react'
import { useTranslation } from 'react-i18next'

const Card = ({title,el} : {title?: string,el?: string}) => {
    const [hoverOn, setHoverOn] = React.useState(false)
    const { t } = useTranslation()

    const lineOnHover = () => {
        setHoverOn(true)
    }

    const lineOffHover = () => {
        setHoverOn(false)
    }
    return (
        <Link
            style={{margin: "200px 0"}}
            href={el ? el :"/files/personal_data_processing.pdf"}
            onMouseEnter={lineOnHover}
            onMouseLeave={lineOffHover}
            className='catalog__product'
        >
            <div className='catalog__product-title'>
                <h3>{title ? title : "Политика обработки и защиты персональных данных"}</h3>
            </div>
            <p className='categories-slider__text'>{hoverOn ? 'Читать' : 'PDF'}</p>
        </Link>
    )
}

export default Card
